import React from 'react';
import { Link } from 'react-router-dom';
import AppImage from '../AppImage';

const Logo = ({ 
  size = "medium", 
  showText = true, 
  className = "",
  linkTo = "/",
  variant = "default" 
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      imageSize: "w-8 h-8",
      textSize: "text-lg",
      spacing: "space-x-2"
    },
    medium: {
      imageSize: "w-10 h-10",
      textSize: "text-xl",
      spacing: "space-x-2"
    },
    large: {
      imageSize: "w-12 h-12",
      textSize: "text-2xl",
      spacing: "space-x-3"
    }
  };

  // Variant configurations
  const variantConfig = {
    default: {
      textColor: "text-gray-900",
      imageClass: ""
    },
    white: {
      textColor: "text-white",
      imageClass: ""
    },
    header: {
      textColor: "text-gray-900",
      imageClass: ""
    }
  };

  const config = sizeConfig?.[size];
  const variantStyle = variantConfig?.[variant];

  const logoContent = (
    <div className={`flex items-center ${config?.spacing} flex-shrink-0 ${className}`}>
      {/* Logo Image */}
      <div className={`${config?.imageSize} flex items-center justify-center overflow-hidden rounded-lg`}>
        <AppImage
          src="/assets/images/LeadGen_Pro_AI_Logo_New_1-1760077350039.png"
          alt="LeadGen Pro AI Logo"
          className={`${config?.imageSize} object-cover rounded-lg ${variantStyle?.imageClass}`}
        />
      </div>
      
      {/* Logo Text */}
      {showText && (
        <span className={`${config?.textSize} font-bold ${variantStyle?.textColor} whitespace-nowrap`}>
          LeadGen Pro AI
        </span>
      )}
    </div>
  );

  // If linkTo is provided, wrap in Link, otherwise return div
  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;